import React, { Component } from 'react'
import '../OnlineHelpPage.css'
import RealTimeCommunication_Elec_001 from './img/RealTimeCommunication_Elec_001.png'
import RealTimeCommunication_Elec_002 from './img/RealTimeCommunication_Elec_002.png'
import RealTimeCommunication_Elec_003 from './img/RealTimeCommunication_Elec_003.png'
import RealTimeCommunication_Elec_004 from './img/RealTimeCommunication_Elec_004.png'
import RealTimeCommunication_Elec_005 from './img/RealTimeCommunication_Elec_005.png'
import RealTimeCommunication_Elec_006 from './img/RealTimeCommunication_Elec_006.png'
export default class ElecRealTimeCommunication extends Component {
  render() {
    return (
      <div className="main-window">
        <div className="main-window-title">即时通信_客户端</div>
        <div className="main-window-content">用户使用即时通信功能与内部人员进行交流</div>
        <img src={RealTimeCommunication_Elec_001} className="main-window-img"></img>
        <img src={RealTimeCommunication_Elec_002} className="main-window-img"></img>
        <img src={RealTimeCommunication_Elec_003} className="main-window-img"></img>
        <img src={RealTimeCommunication_Elec_004} className="main-window-img"></img>
        <img src={RealTimeCommunication_Elec_005} className="main-window-img"></img>
        <img src={RealTimeCommunication_Elec_006} className="main-window-img"></img>
      </div>
    )
  }
}
